import ApiClient from '../../../../base/api';
import {
    LoginParams,
    PasswordResetParams,
    SignUpParams,
    QuickSignUpParams,
    ValidateSignUpParams,
    PasswordSetNewParams,
} from './interfaces';

const apiClient = new ApiClient();

export const authApi = {
    signUp: (data: SignUpParams) => apiClient.post<SignUpParams, void>('/api/sign-up ', data),
    quickSignUp: (data: QuickSignUpParams) => apiClient.post<QuickSignUpParams, void>('/api/quick-sign-up ', data),
    validateSignParams: (data: ValidateSignUpParams) => apiClient.post<ValidateSignUpParams, void>('/api/sign-up ', data),
    login: (data: LoginParams) => apiClient.post<LoginParams, void>('/api/login ', data),
    passwordReset: (data: PasswordResetParams) => apiClient.post<PasswordResetParams, void>('/api/password-reset ', data),
    passwordSetNew: (data: PasswordSetNewParams) => apiClient.post<PasswordSetNewParams, void>('/api/password-set ', data),
};
